export const goalUidSlugMap = {
  KSCGY: 'upsc-civil-services-examination-ias-preparation',
  TMUVD: 'jee-main-and-advanced-preparation',
  YOTUH: 'neet-ug',
  VLEMN: 'ssc-exams',
  MAFGF: 'gre-graduate-record-examination-preparation',
  XNDUS: 'cat-common-admission-test-preparation',
  TEWDQ: 'nta-ugc-net',
  RTPSX: 'bank-exams',
  BBKWG: 'ca-chartered-accountancy-preparation',
  MRZFY: 'law-entrance-exams',
  DZVHL: 'international-english-language-testing-system',
  GWDPV: 'madhya-pradesh-public-service-commission',
  GNFFE: 'maharashtra-public-service-commission',
  FHWHO: 'punjab-public-service-commission',
  QJEJG: 'railway-exams',
  SCANJ: 'rajasthan-public-service-commission',
  XCTVJ:
    'uttar-pradesh-public-service-commissionuttar-pradesh-subordinate-services-selection-commission',
  EWFJR: 'english-language',
  NJHPJ: 'campus-placements',
  SUVLV: 'class-9',
  GSZGO: 'class-10',
  GWDPZ: 'class-11',
  DOZGI: 'personal-development',
  ZISFF: 'tamil-nadu-public-service-commission',
  TUNWK: 'cdsafcatcapf',
  LGQVU: 'gmat-graduate-management-admission-test',
  PESHE: 'gate',
  LVECA: 'karnataka-public-service-commission',
  QKHZF:
    'andhra-pradesh-public-service-commission-telangana-state-public-service-commission',
  ZIUBD: 'kerala-public-service-commission',
  RJVOD: 'gujarat-public-service-commission',
  UQCMN: 'west-bengal-public-service-commission',
  JJTHM: 'dsssb-delhi-subordinate-services-selection-board',
  HQDXE: 'ujian-tulis-berbasis-komputer-sbmptn',
  BIZXQ: 'csir-ugc-net',
  QOIVT: 'bpsc-bihar-public-service-commision',
  QZIXN: 'exame-nacional-do-ensino-medio',
  GMXMZ: 'teacher-eligibility-test-tet',
  IFKUZ: 'uptet',
  PLWCX: 'class-12-board',
  XTKHH: 'opsc',
  ZKXEQ: 'haryana-public-service-commission',
  EGKYI: 'jammu-kashmir-public-services',
  SIFWL: 'iit-jam',
  SDDOC: 'neet-pg',
  WXKBF: 'madhya-pradesh-teacher-eligibility-test',
  AELON: 'jharkhand-public-service-commission',
  DOKOV: 'programming',
  MCRYW: 'company-secretary',
  SWBEI: 'rajasthan-teacher-eligibility-test',
  WJWZU: 'haryana-teacher-eligibility-test',
  DANNJ: 'ndaairforce-x-ynavy',
  JXGKD: 'hppsc',
  QFJOA: 'engineering-services-examination',
  TPSBK: 'foundation-ntse'
};

const reverseSlugUidMap = () => {
  const result = {};
  Object.keys(goalUidSlugMap).forEach((key) => {
    const value = goalUidSlugMap[key];
    result[value] = key;
  });
  return result;
};

export const goalSlugUidMap = reverseSlugUidMap();

export const menus = [
  { label: 'Privacy policy', url: { href: '/privacy', as: '/privacy' } },
  { label: 'Terms and conditions', url: { href: '/terms', as: '/terms' } },
  { label: 'User guidelines', url: { href: '/guidelines', as: '/guidelines' } },
  {
    label: 'Refund Policy',
    url: { href: '/refund-policy', as: '/refund-policy' }
  },
  {
    label: 'Legal Notices',
    url: { href: '/legal-notices', as: '/legal-notices' }
  },
  {
    label: 'Subscription T&C',
    url: { href: '/subscription-terms', as: '/subscription-terms' }
  },
  {
    label: 'Live Classroom T&C',
    url: { href: '/classroom-terms', as: '/classroom-terms' }
  },
  {
    label: 'Combat T&C',
    url: { href: '/combat-terms', as: '/combat-terms' }
  },
  {
    label: 'Referral T&C',
    url: { href: '/referral-terms', as: '/referral-terms' }
  }
];

export const legalPageRoutes = [
  '/privacy',
  '/terms',
  '/guidelines',
  '/refund-policy',
  '/legal-notices',
  '/subscription-terms'
];

export const tabletRoutes = ['/explore', '/manage-goals'];
